<template>
    <a-dropdown :trigger="['click']">
        <i class="fa fa-th"></i>
        <a-menu slot="overlay" style="max-width: 300px; max-height: 200px;overflow-y: auto">
            <a-checkbox-group  v-model="value" @change="checkChange">
                <a-row style="padding: 0 10px;">
                    <div v-for="item in columns" :key="item.key" :title="item.title"><a-checkbox :value="item.key">{{item.title}}</a-checkbox></div>
                </a-row>
            </a-checkbox-group>
        </a-menu>
    </a-dropdown>
</template>

<script>
    export default {
        name: "TableColumns",
        props: {
          columns: {
              type: Array,
              default: []
          }
        },
        data(){
            return {
                value: []
            }
        },
        mounted(){
            this.initTableColumns();
        },
        methods: {
            initTableColumns(){
                this.columns.forEach(item => {
                    if(item.show){
                        this.value.push(item.key)
                    }
                })
            },
            checkChange(checkedValues){
                let result = this.columns.filter(item => {
                    return checkedValues.includes(item.key)
                });
                this.$emit('getFilterColumns', result)
            }
        }
    }
</script>
